import axios from "axios";
import {API} from '@/env'
import Vuex from '@/store'
import router from "../../router";

export default {
    /**
     * Add Team
     * @api {POST} /api/web/addTea
     * @data form_Data
     */
    add_team(data) {
        const options = {
            method: 'POST',
            url: API + 'api/web/addTeam',
            headers: {'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token},
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                reject(error.response.data)
            })
        })
    },


    /**
     * Add Team Member
     * @api {POST} /api/web/addPlayerTwo
     * @data
     */
    add_member(data) {
        const options = {
            method: 'POST',
            url: API + 'api/web/addPlayerTwo',
            headers: {'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error.response.data.message)
            })
        })
    },

    /**
     * Get My Team
     * @api {GET} /api/web/myTeams
     * @data
     */
    get_my_team() {
        const options = {
            method: 'POST',
            url: API + 'api/web/myTeams',
            headers: {'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token},
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error.response.data)
               if(error.response.data.message === 'Token is Invalid') {
                   window.location.href = '/sign-In'
               }

            })
        })
    },

    /**
     * Accept Or Refuse Team invitation
     * @api {POST} /api/web/myTeams
     * @data
     */
    accpet_or_refuse_team(data) {
        const options = {
            method: 'POST',
            url: API + 'api/web/PlayerTwoAcceptOrRefused',
            headers: {'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token},
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        })
    },

    /**
     * Delete Member From Team
     * @api {POST} /api/web/PlayerOneDelete
     * @data
     */
    delete_member(data) {
        const options = {
            method: 'POST',
            url: API + 'api/web/PlayerOneDelete',
            headers: {'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token},
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error.response.data.message)
            })
        })
    },


    update_team(data) {
        const options = {
            method: 'POST',
            url: API + 'api/web/updateMyTeam',
            headers: {'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token},
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                reject(error.response.data)
            })
        })
    },

    /**
     * update all details of team info
     * @api {POST}
     */
    update_all_teamInfo(team_id, data) {
        const options = {
            method: 'POST',
            url: API + `api/web/updateTeaminfo/${team_id}`,
            headers: {'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token},
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error.response.data.message)
            })
        })
    },

    /**
     * Get My Team
     * @api {GET} /api/web/team/members
     * @data
     */
     get_team_members(team_id) {
        const options = {
            method: 'GET',
            url: API + 'api/web/team/members/' + team_id ,
            headers: {'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token},
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error.response.data)
               if(error.response.data.message === 'Token is Invalid') {
                   window.location.href = '/sign-In'
               }

            })
        })
    },
}